import React from 'react';
import Media, { MediaProps } from '../Media';
import { CardTop, CardBottom } from '../CardPieces';
import { CardContentProps } from '../CardContent';

import CardBase from '../CardBase';
import cls from '@soluto-design/styles/cls';

export interface CardMediaSmallProps extends CardContentProps {
    media?: MediaProps['media'];
}

export default function CardMediaSmall({
    tag,
    title,
    text,
    date,
    persons,
    media,
    cta,
}: CardMediaSmallProps) {
    return (
        <>
            <CardBase
                href={cta?.href}
                className={cls(
                    'group overflow-hidden rounded-large bg-background-brand-primary flex flex-col',
                    cta?.disabled && 'bg-background-disabled',
                )}>
                <CardTop
                    tag={tag}
                    title={title}
                    className={cls(
                        'flex flex-col gap-xs px-lg pt-lg pb-xs [&>h4]:md:min-h-[2lh]',
                        !cta?.disabled &&
                            !!media &&
                            'md:pb-lg md:group-hover:pb-xs md:group-focus-visible:pb-xs md:transition-all md:ease-in-out md:duration-300',
                    )}
                />

                <div
                    className={cls(
                        'relative h-full pb-[calc(var(--soluto-spacing-lg)+100px)] px-lg',
                        !cta?.disabled &&
                            !!media &&
                            'md:pb-xs md:group-hover:pb-lg md:group-focus-visible:pb-lg md:transition-all md:ease-in-out md:duration-300',
                    )}>
                    <CardBottom
                        text={text}
                        date={date}
                        cta={cta}
                        buttonTabIndex={-1}
                        persons={persons}
                        className={cls(!date && 'flex flex-col !gap-[40px]')}
                    />

                    {media && (
                        <div
                            className={cls(
                                'absolute bottom-0 left-0 w-full h-[100px] md:h-full z-10',
                                !cta?.disabled &&
                                    !!media &&
                                    'md:group-hover:translate-y-full md:group-focus-visible:translate-y-full md:transition-transform md:ease-in-out md:duration-300 bg-background-secondary',
                            )}>
                            <Media media={media} layout="fill" />
                        </div>
                    )}
                </div>
            </CardBase>
        </>
    );
}
